import { createSlice } from "@reduxjs/toolkit";
import { clearAllStories, getAndUpdateStoriesAsync } from "../actions";
import {
  nonSubToSubStoryAsync,
  // updatePaidStoryIsPaidAsync,
  updateStoryLikeStatus,
  updateStoryViewStatus,
} from "../actions/storiesData";
import { store } from "../store";

const initialState = {
  stories: [],
  storiesNonSub: [],
  liveEvent: [],
  liveEventNonSub: [],
  loading: false,
  loadingStoryOfInfluncer: false,
};

const categoriseStoryByInfluencer = (stories) => {
  if (!stories.length) return [];

  const result = stories.reduce((acc, item) => {
    const influencerId = item._createdBy?._id;
    const existingInfluencer = acc.find(
      (influencer) => influencer?._createdBy?._id === influencerId
    );

    if (existingInfluencer) {
      existingInfluencer.stories.push(item);
    } else {
      acc.push({
        _createdBy: item?._createdBy,
        stories: [item],
      });
    }
    return acc;
  }, []);

  return result;
};

const storiesDataSlice = createSlice({
  name: "storiesData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(clearAllStories, (state, action) => {
        state.stories = [];
      })

      .addCase(getAndUpdateStoriesAsync.pending, (state) => {
        state.loading = true;
      })

      .addCase(getAndUpdateStoriesAsync?.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getAndUpdateStoriesAsync.fulfilled, (state, payload) => {
        state.stories = categoriseStoryByInfluencer(payload?.payload?.stories);
        state.storiesNonSub = categoriseStoryByInfluencer(
          payload?.payload?.storiesNonSub
        );
        state.liveEvent = payload?.payload?.liveEvent;
        state.liveEventNonSub = payload?.payload?.liveEventNonSub;
        state.loading = false;
      })
      .addCase(updateStoryLikeStatus, (state, action) => {
        const { id, isLiked } = action.payload;
        state.stories = state.stories.map((story) => ({
          ...story,
          stories: story.stories.map((item) =>
            item._id === id ? { ...item, isLiked } : item
          ),
        }));
      })
      .addCase(updateStoryViewStatus, (state, action) => {
        const { id, isViewed } = action.payload;
        state.stories = state.stories.map((story) => ({
          ...story,
          stories: story.stories.map((item) =>
            item._id === id ? { ...item, isViewed } : item
          ),
        }));
        state.storiesNonSub = state.storiesNonSub.map((story) => ({
          ...story,
          stories: story.stories.map((item) =>
            item._id === id ? { ...item, isViewed } : item
          ),
        }));
      })
      // .addCase(updatePaidStoryIsPaidAsync.fulfilled, (state, action) => {
      //   debugger
      //   const { id, newStoryData } = action.payload;
      //   console.log(newStoryData)
      //   state.stories = state.stories.map((storyGroup) => ({
      //     ...storyGroup,
      //     stories: storyGroup.stories.map((item) =>
      //       item._id === id ? { ...item,  ...newStoryData} : item
      //     ),
      //   }));
      // })      
      // .addCase(updatePaidStoryIsPaidAsync.fulfilled, (state, action) => {
      //   const { id, newStoryData } = action.payload;
      //   console.log("Reducer received >>>", id, newStoryData);
      
      //   state.stories = state.stories.map((storyGroup) => ({
      //     ...storyGroup,
      //     stories: storyGroup.stories.map((item) => {
      //       if (item._id === id) {
      //         const { bluredImage, ...rest } = item; // remove bluredImage
      //         return {
      //           ...rest,
      //           isPaid: newStoryData?.isPaid,
      //         };
      //       }
      //       return item;
      //     }),
      //   }));
      // })      
      .addCase(nonSubToSubStoryAsync.fulfilled, (state, action) => {
        const newStory = action.payload;
          if(newStory.length){state.stories=[{
            _createdBy: newStory[0]._createdBy,
            stories: [...newStory],
          }
          ]
          delete state.storiesNonSub;
        }
      });
     
  },
});

export const storiesDataReducer = storiesDataSlice.reducer;
